// extracted by mini-css-extract-plugin
module.exports = {"banner-text-bold":"_93444fe79c--banner-text-bold--gDIvc"};